import { render, staticRenderFns } from "./_AdicionarImagem.vue?vue&type=template&id=09ffaf25&scoped=true"
import script from "./_AdicionarImagem.vue?vue&type=script&lang=ts"
export * from "./_AdicionarImagem.vue?vue&type=script&lang=ts"
import style0 from "./_AdicionarImagem.vue?vue&type=style&index=0&id=09ffaf25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ffaf25",
  null
  
)

export default component.exports